"use client";

import { useTranslations } from "next-intl";

/** 绿底白勾，与稿图一致 */
function CheckBullet() {
	return (
		<div
			className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#76a734]"
			aria-hidden
		>
			<svg className="h-3.5 w-3.5 text-white" viewBox="0 0 12 10" fill="none" aria-hidden>
				<path
					d="M1 5l3.5 3.5L11 1"
					stroke="currentColor"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</div>
	);
}

const ADVANTAGE_ITEM_KEYS = [
	{ titleKey: "adv1_title", descKey: "adv1_desc" },
	{ titleKey: "adv2_title", descKey: "adv2_desc" },
	{ titleKey: "adv3_title", descKey: "adv3_desc" },
	{ titleKey: "adv4_title", descKey: "adv4_desc" },
] as const;

const APPLICATION_ITEM_KEYS = [
	{ titleKey: "app1_title", descKey: "app1_desc" },
	{ titleKey: "app2_title", descKey: "app2_desc" },
	{ titleKey: "app3_title", descKey: "app3_desc" },
	{ titleKey: "app4_title", descKey: "app4_desc" },
] as const;

/**
 * Plastic Injection Molding：双栏「优势 / 应用」，各占一半宽，左对齐 + 勾选列表
 */
export default function PlasticInjectionMoldingAdvantagesApplications() {
	const t = useTranslations("plasticInjectionMoldingAdvantagesApplications");

	return (
		<section className="w-full bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="grid grid-cols-1 gap-12 text-left lg:grid-cols-2 lg:gap-10 xl:gap-16">
					{/* 左：Advantages */}
					<div className="min-w-0">
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("advantagesTitle")}
						</h2>
						<p className="mb-8 text-sm leading-relaxed text-gray-900 sm:mb-10 md:text-base">
							{t("advantagesIntro")}
						</p>
						<ul className="flex flex-col gap-6 sm:gap-7">
							{ADVANTAGE_ITEM_KEYS.map((keys) => (
								<li key={keys.titleKey} className="flex gap-3 sm:gap-4">
									<CheckBullet />
									<div className="min-w-0">
										<h3 className="mb-1.5 text-base font-semibold text-black sm:text-lg">
											{t(keys.titleKey)}
										</h3>
										<p className="text-sm leading-relaxed text-gray-900 md:text-base">{t(keys.descKey)}</p>
									</div>
								</li>
							))}
						</ul>
					</div>

					{/* 右：Applications */}
					<div className="min-w-0">
						<h2 className="mb-3 text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
							{t("applicationsTitle")}
						</h2>
						<p className="mb-8 text-sm leading-relaxed text-gray-900 sm:mb-10 md:text-base">
							{t("applicationsIntro")}
						</p>
						<ul className="flex flex-col gap-6 sm:gap-7">
							{APPLICATION_ITEM_KEYS.map((keys) => (
								<li key={keys.titleKey} className="flex gap-3 sm:gap-4">
									<CheckBullet />
									<div className="min-w-0">
										<h3 className="mb-1.5 text-base font-semibold text-black sm:text-lg">
											{t(keys.titleKey)}
										</h3>
										<p className="text-sm leading-relaxed text-gray-900 md:text-base">{t(keys.descKey)}</p>
									</div>
								</li>
							))}
						</ul>
					</div>
				</div>
			</div>
		</section>
	);
}
